// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"p2-z","colorTextValue":"q2-z","swatches":"r2-z","collapseLink":"s2-z","isCollapsed":"t2-z","dropdown":"u2-z","disabled":"v2-z"};